import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Rebar from "../src/Screens/Rebar/Rebar";
import Truck_Form from "../src/Screens/TruckMaster/TruckForm";
import TruckDetails from "../src/Screens/TruckMaster/TruckDetails";
import DelNote from "../src/Screens/DeliveryNote/DelNote";
import GatePass from "../src/Screens/GatePass/GatePass";
import Transportation_Dashboard from "./Screens/TransportationDashboard/Transportation";
import ElementStatus_Dashboard from "./Screens/ElementStatusDashboard/ElementStatus";
import ElementStatus_Details from "./Screens/ElementStatusDashboard/ElementStatusDetails";
import Retention from "./Screens/RetentionDashboard/Retention";
import Hold from "./Screens/HoldOrCancel/Hold";
import Stock_grid from "./Screens/StockOffload/Stockgrid";
import ApRetention_Dashboard from "./Screens/APRetentionDashboard/ApRetention";
import Site_Planner from "./Screens/SitePlanner/SitePlanner";
import UnHold from "./Screens/UnHoldOrCancel/UnHold";
import OffloadDetails from "./Screens/StockOffload/OffloadDetails";
import Load_grid from "./Screens/StockLoading/Loadgrid";
import LoadForm from "./Screens/StockLoading/Loadform";
import LoadCustom from "./Screens/StockLoading/LoadCustom";
import LoadLines from "./Screens/StockLoading/LoadLines";
import BatchingPlant from "./Screens/BatchingPlantControl/BatchingPlant";
import ApprovalGrid from "./Screens/ApprovalSetup/ApprovalGrid";
import ApprovalCode from "./Screens/ApprovalSetup/ApprovalCode";
import ApprovalForm from "./Screens/ApprovalSetup/Approvalform";
import BlockUtility from "./Screens/BlocksUtility/BlocksUtility";
import HollowLanding from "./Screens/HollowCore/HollowLanding";
import Hollowform from "./Screens/HollowCore/Hollowform";
import ApproveGrid from "./Screens/ApproveElement/ApproveGrid";
import Form from "./InputForm/Form";
import Reinforcement from "./Reinforcement/Reinforcement";
import Manhole from "./Screens/Manhole/Manhole";
import ReinfocementV2 from "./Screens/ReinforcementV2/Reinforcement.js";
import ReinforcementDet from "./Screens/ReinforcementV2/ReinforcementrDet.js";
import TransportationDetails_Dashboard from "./Screens/TransportationDashboard/Transportation-Details.js";
import CastingDraw from "./Screens/ElementVisulization/CastingDraw.js";
import React from "react";
import ErrorPage from "./InputForm/ErrorPage.js";
function App() {
  document.body.style.backgroundColor = "#edf2f5";
  // document.body.style.zoom = "90%";
  // AAC State for persistance
  const [formData, setFormData] = React.useState([]);
  const [fetchedData, setFetchedData] = React.useState();
  const [profile, setProfile] = React.useState("FS+BLK");
  const [moldId, setMoldId] = React.useState("");
  const [thickness, setThickness] = React.useState("");
  const [width, setWidth] = React.useState("");
  const [length, setLength] = React.useState("");
  const [Qty, setQty] = React.useState("");

  return (
    <Router>
      {/* <MyNavbar />
      <MyToolbar /> */}
      <Routes>
        <Route path="/rebar" element={<Rebar />} />
        <Route path="/truck" element={<Truck_Form />} />
        {/* Nested Routes for Truck */}
        <Route path="/truck/truckdet/:truckId" element={<TruckDetails />} />
        <Route path="/" Component={DelNote} />
        <Route path="/gatepass" element={<GatePass />} />
        <Route path="/elementstatus" Component={ElementStatus_Dashboard} />
        <Route path="/elementstatus/details/:projID" Component={ElementStatus_Details} />
        <Route path="/transportation" Component={Transportation_Dashboard} />
        <Route
          path="/transportation/details/:transportid"
          Component={TransportationDetails_Dashboard}
        />
        <Route path="/retention" element={<Retention />} />
        <Route path="/hold" element={<Hold />} />
        <Route path="/unhold" element={<UnHold />} />
        <Route path="/apretention" Component={ApRetention_Dashboard} />
        <Route path="/siteplanner" Component={Site_Planner} />
        {/* Stock Offload */}
        <Route path="/stockgrid" Component={Stock_grid} />
        <Route path="/stockgrid/offdetails/:offloadID" Component={OffloadDetails} />
        {/* Stock Loading */}
        <Route path="/stockload" Component={Load_grid} />
        <Route path="/stockload/loadform/:loadID" Component={LoadForm} />
        <Route path="/stockload/loadform" Component={LoadForm} />
        <Route path="/stockload/loadcustom" Component={LoadCustom} />
        <Route path="/stockload/loadlines" Component={LoadLines} />
        {/* Batching Plant */}
        <Route path="/batching" Component={BatchingPlant} />
        {/* Approval  */}
        <Route path="/approval" Component={ApprovalGrid} />
        <Route path="/approval/approvalcode" Component={ApprovalCode} />
        <Route path="/approval/approvalform/:approvalID" Component={ApprovalForm} />
        {/* block utility */}
        <Route path="/BlocksUtility/BlocksUtility" Component={BlockUtility} />
        <Route path="/hollowform/:slabid" element={<Hollowform />} />
        {/* Hollowcore */}
        <Route path="/Hollow" Component={HollowLanding} />
        {/* Approve element  */}
        <Route path="/approveElement" Component={ApproveGrid} />
        <Route
          path="/form/:tenantId/*"
          element={
            <Form
              formData={formData}
              setFormData={setFormData}
              fetchedData={fetchedData}
              setFetchedData={setFetchedData}
              profile={profile}
              setProfile={setProfile}
              moldId={moldId}
              setMoldId={setMoldId}
              thickness={thickness}
              setThickness={setThickness}
              width={width}
              setWidth={setWidth}
              length={length}
              setLength={setLength}
              Qty={Qty}
              setQty={setQty}
            />
          }
        />
        <Route path="/error" Component={ErrorPage} />

        <Route
          path="/form/Reinforcement/"
          Component={Reinforcement}
          state={[formData, setFormData]}
        />
        <Route path="/form/Reinforcement/:partLot_LotNum/:company" Component={Reinforcement} />
        <Route path="/Manhole" Component={Manhole} />
        <Route path="/reinforcement" Component={ReinfocementV2} />
        <Route path="/reinforcementdet" Component={ReinforcementDet} />
        <Route path="/castdraw" Component={CastingDraw} />
      </Routes>
    </Router>
  );
}

export default App;
